import SkeletonRootCategoryTab from '@/components/common/navigation/skeleton/SkeletonRootCategoryTab'

export { SkeletonRootCategoryTab }
